import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FIELD_SPORTS } from '@/lib/sportStats';

export function StatsSummary({ currentEvent, filterOptions }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="text-sm text-slate-500">Total Matches</div>
          <div className="text-2xl font-bold text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }} data-testid="stat-total-matches">
            {currentEvent.schedule?.length || 0}
          </div>
        </CardContent>
      </Card>
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="text-sm text-slate-500">Game Days</div>
          <div className="text-2xl font-bold text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }} data-testid="stat-game-days">
            {filterOptions.days.length}
          </div>
        </CardContent>
      </Card>
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="text-sm text-slate-500">{FIELD_SPORTS.includes((currentEvent?.sport || '').toLowerCase()) ? 'Fields Used' : 'Courts Used'}</div>
          <div className="text-2xl font-bold text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }} data-testid="stat-courts-used">
            {filterOptions.courts.length}
          </div>
        </CardContent>
      </Card>
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="text-sm text-slate-500">Locked Matches</div>
          <div className="text-2xl font-bold text-[#00247D]" style={{ fontFamily: 'Barlow Condensed' }} data-testid="stat-locked-matches">
            {currentEvent.schedule?.filter(m => m.locked).length || 0}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
